module.exports = __webpack_public_path__ + "static/media/icon_announcement.4fba1369.png";